import ScrollTo from './ScrollTo';

export default ScrollTo;
